import { render, staticRenderFns } from "./SglBed.vue?vue&type=template&id=b7ea426e&"
import script from "./SglBed.vue?vue&type=script&lang=js&"
export * from "./SglBed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports